export default {
    monitor: {name: "Moniteur"},
    keyboard: {name: "Clavier"},
    mouse: {name: "Souris"},
    webcam: {name: "Webcam"},
    headset: {name: "Casque"},
    dockingStation: {name: "Station d'accueil"},
}